
import { Vue, Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import LevelChart from "../atoms/LevelChart.vue";
export const CulturalFitTrendMap = [
  ["支援型", "自律型"],
  ["保守", "革新"],
  ["指示命令", "権限移譲"],
  ["年功序列", "成果主義"],
  ["アットホーム", "ドライ"]
];
@Options({
  components: {
    LevelChart
  }
})
export default class CulturalFitChart extends Vue {
  @Prop({ type: Array }) chartData!: { name: string; value: number }[];
  trend(index: number) {
    return CulturalFitTrendMap[index];
  }
}
